import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.GOALS_AND_OBJECTIVES}` as const;

export interface IGoalsAndObjectivesExecutiveSummaryForm {}

export const goalsAndObjectivesExecutiveSummaryInitialValues: IGoalsAndObjectivesExecutiveSummaryForm = {};
